/*
 * Axios.js
 *
 * Speakers
 * Created by Mahdi Yousefpour on Thu Feb 02 2023 mys Company
 */

import axios from 'axios'
import { toBase64 } from '../../utilities/mysUtilities'
import { BASE_URL, getToken } from '../constant/constants'
import { localization } from '../localize/localizable'

export const axiosInstance = (version, endPoint, params, method, headers, body) => {
    headers.appData = toBase64(JSON.stringify(appDataHeader))
    if (endPoint !== 'login' && endPoint !== 'activation') headers.Authorization = 'Bearer ' + getToken()
    try {
        return axios.request({
            method,
            params,
            headers,
            url: BASE_URL + (version ? version + '/' : '') + endPoint,
            data: body,
        })
    } catch (error) {
        // console.log(error)
        return null
    }
}

axios.interceptors.response.use(
    (response) => {
        return response // <- I want to trigger this callback
    },
    (error) => {
        // <- so far i can only trigger a response error
        if (error?.isLocal) {
            return Promise.resolve(error.data)
        }

        return Promise.reject(error)
    }
)

export const Methods = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
}

localization.setLanguage('fa-IR')

export const appDataHeader = {
    culture: localization.getLanguage(),
    platform: 'PANEL',
    imei: '',
    store: 'WEEBSITE',
    osVersion: 'MacOS',
    modelNumber: '5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/103.0.0.0 Safari/537.36',
    deviceName: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/103.0.0.0 Safari/537.36',
    manufacturer: 'Google Inc.',
}
